module.exports = __webpack_public_path__ + "static/media/kelloggs all bran.52d38dd8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/kelloggs all bran.gif
// module id = 370
// module chunks = 0